const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-questionnaires",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    getOne({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/${id}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    create({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    update({ dispatch, state, rootState }, { id, ...data }) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/${id}`,
            method: "PUT",
            data,
          },
          { root: true }
        );
      }
    },
    delete({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/${id}`,
            method: "DELETE",
            data: {},
          },
          { root: true }
        );
      }
    },
  },
};
